import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import '../../assets/account/no-user-avatar.png.mjs';
import { imageSrc } from '../../utils/asset.mjs';
import '../CustomImage/index.mjs';
import { Container } from './Avatar.styles.mjs';
import NoUserAvatar__default from "../../assets/no-user-avatar.png";
import { CustomImage } from '../CustomImage/CustomImage.mjs';
"use strict";
const SIZES = {
  small: 20,
  medium: 48
};
const NoUserAvatarSrcLink = imageSrc(NoUserAvatar__default);
const Avatar = function Avatar2({
  renderImage,
  src,
  alt,
  size,
  className
}) {
  const width = useMemo(() => {
    return SIZES[size] ?? SIZES.medium;
  }, [size]);
  const srcLink = src ? imageSrc(src) : NoUserAvatarSrcLink;
  return /* @__PURE__ */jsx(Container, {
    className,
    $size: width,
    children: /* @__PURE__ */jsx(CustomImage, {
      renderImage,
      asset: {
        src: srcLink,
        alt: alt ?? "",
        width,
        height: width
      },
      sizes: `${width}px`,
      objectFit: "cover"
    })
  });
};
export { Avatar, SIZES };
//# sourceMappingURL=Avatar.mjs.map
